import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Store, CheckCircle2, AlertCircle, Loader2, Link2 } from "lucide-react";
import { toast } from "sonner";

const Row = ({ ok, label, testId }) => (
  <div data-testid={testId} className="flex items-center gap-2 text-sm">
    {ok ? <CheckCircle2 size={16} className="text-[#4E7363]" /> : <AlertCircle size={16} className="text-[#C29638]" />}
    <span className="text-[#5C534E]">{label}</span>
  </div>
);

export const ShopifyStatus = () => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    api.get("/admin/shopify-status").then(({ data }) => setSt(data)).catch(() => setSt(false));
    const q = new URLSearchParams(window.location.search).get("shopify");
    if (q === "connected") toast.success("Shopify collegato con successo!");
    if (q === "error") toast.error("Collegamento Shopify non riuscito. Riprova.");
  }, []);
  const installUrl = `${process.env.REACT_APP_BACKEND_URL}/api/shopify/install`;

  return (
    <div className="rounded-2xl bg-white border border-[#EAE3DC] p-6 mb-6" data-testid="shopify-status">
      <div className="flex items-center gap-2 mb-4">
        <Store size={18} className="text-[#4E7363]" />
        <h3 className="font-display font-medium text-[#2D2825]">Connessione Shopify API</h3>
        {st && <span className="ml-auto text-xs text-[#8C7F78]">{st.shop}</span>}
      </div>
      {st === null && <div className="flex items-center gap-2 text-sm text-[#8C7F78]"><Loader2 className="animate-spin" size={15} /> Verifica in corso…</div>}
      {st === false && <p className="text-sm text-[#B85750]">Impossibile verificare lo stato.</p>}
      {st && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <Row testId="shopify-admin-ok" ok={st.admin_ok} label={st.admin_ok ? `Admin API attiva (${st.shop_name})` : "Admin API non attiva"} />
          <Row testId="shopify-storefront-ok" ok={st.storefront_ok} label={st.storefront_ok ? "Checkout nativo attivo" : "Checkout: link carrello"} />
          <Row testId="shopify-catalog-source" ok={st.catalog_source === "admin_api"} label={`Catalogo: ${st.catalog_source === "admin_api" ? "Admin API" : "feed pubblico"}`} />
          <div className="text-sm text-[#5C534E]" data-testid="shopify-checkouts">Mamme con checkout: <strong>{st.checkouts}</strong></div>
        </div>
      )}
      {st && !st.admin_ok && (
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl bg-[#FDF6E7] p-3" data-testid="shopify-error">
          <p className="text-xs text-[#8a6a22] flex-1">
            Shopify non è ancora autorizzato. Clicca "Collega Shopify" e conferma nel pannello del negozio.
          </p>
          <a href={installUrl} data-testid="shopify-connect-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#4E7363] hover:bg-[#3d5a4e] text-white px-5 py-2 text-sm transition-colors">
            <Link2 size={15} /> Collega Shopify
          </a>
        </div>
      )}
    </div>
  );
};
